import { useTranslation } from "react-i18next";
import { SelectField, TextField } from "@/shared/ui/core";
import { TextAreaField } from "@/features/admin/components";
import { EditorialBlock, type EditorialBlockLocaleProps } from "./EditorialBlock";
import { EditorialIconField } from "./EditorialIconField";
import { useBlockFilled } from "./useBlockFilled";
import { useEditorialThemeOptions } from "../../productOptions";

/**
 * Bloque 9 · La comparación de dos columnas.
 *
 * Son exactamente DOS lados y no una lista: el contrato los llama `left`
 * y `right` porque la ficha los pinta enfrentados, y una comparación de
 * tres no se puede enfrentar. Por eso aquí no hay botón de añadir.
 */
export function EditorialSideBySideBlock({ locale }: EditorialBlockLocaleProps) {
  const { t } = useTranslation();
  const name = `editorial.${locale}.sideBySide`;
  const filled = useBlockFilled(name);
  const themeOptions = useEditorialThemeOptions();

  return (
    <EditorialBlock
      name={name}
      title={t("Comparación")}
      description={t("Dos lados enfrentados: antes y después, con y sin.")}
      filled={filled}
    >
      <TextField
        name={`${name}.title`}
        label={t("Título del bloque")}
        placeholder={t("La diferencia")}
      />
      <SelectField
        name={`${name}.theme`}
        label={t("Tema")}
        options={themeOptions}
        placeholder={t("El de la ficha")}
      />

      {(["left", "right"] as const).map((side) => (
        <div
          key={side}
          className="grid grid-cols-1 gap-4 rounded-2xl border border-ds-border bg-ds-cream-2/40 p-4"
        >
          <p className="text-[11px] font-semibold uppercase tracking-ds-label-wide text-ds-ink-3">
            {side === "left" ? t("Lado izquierdo") : t("Lado derecho")}
          </p>
          <TextField
            name={`${name}.${side}.title`}
            label={t("Título")}
            placeholder={side === "left" ? t("Sin el producto") : t("Con el producto")}
          />
          <EditorialIconField name={`${name}.${side}.icon`} />
          <TextAreaField
            name={`${name}.${side}.description`}
            label={t("Descripción")}
            rows={3}
          />
        </div>
      ))}
    </EditorialBlock>
  );
}
